export default {
  highcharts: {
    decimalPoint: ',',
    downloadJPEG: 'Pobierz obraz JPEG',
    downloadPDF: 'Pobierz dokument PDF',
    downloadPNG: 'Pobierz obraz PNG',
    downloadSVG: 'Pobierz obraz SVG',
    exportButtonTitle: 'Eksport',
    forexRate: 'Kurs średni FOREX',
    loading: 'Ładowanie...',
    months: [
      'Styczeń',
      'Luty',
      'Marzec',
      'Kwiecień',
      'Maj',
      'Czerwiec',
      'Lipiec',
      'Sierpień',
      'Wrzesień',
      'Październik',
      'Listopad',
      'Grudzień',
    ],
    printButtonTitle: 'Drukowanie',
    rangeSelectorFrom: 'Od',
    rangeSelectorTo: 'Do',
    rangeSelectorZoom: 'Przybliżenie',
    rateTypes: {
      ask: 'Najlepsza oferta sprzedaży',
      bid: 'Najlepsza oferta kupna',
      forex: 'Średni kurs na świecie',
    },
    resetZoom: 'Reset',
    resetZoomTitle: 'Reset',
    shortMonths: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
    thousandsSep: ' ',
    weekdays: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
    wtBestAsk: 'Najlepsza oferta sprzedaży',
    wtBestBid: 'Najlepsza oferta kupna',
  },
  calculator: {
    title: 'Einsparungen im Walutomat berechnen',
    forBuy: 'für',
    unsupportedPair: 'Wir bieten derzeit keine Kurse für das ausgewählte Währungspaar an.',
    spinnerError: {
      generic: 'Beim Herunterladen der Daten ist ein Fehler aufgetreten',
      toManyRequests:
        'Der Rechner wird derzeit von sehr vielen Nutzern verwendet. Versuchen Sie es später erneut oder wenden Sie sich an den Kundendienst <a href="https://www.walutomat.com/de/kontakt/">https://www.walutomat.com/de/kontakt/</a>.',
    },
    commissionWT: 'Walutomat-Provision',
    continueButton: 'Austausch fortsetzen',
    amountText: 'Betrag',
  },
  dashboard: {
    canEditPost: 'Możesz edytować wpis',
    postExists: 'Wpis o takim tytule już istnieje',
    postNotExists: 'Wpis o takim tytule nie istnieje',
    emptyPostTitle: 'Dodaj tytuł wpisu',
    error: 'Coś poszło nie tak :(',
  },
  continueButton: {
    createAccount: 'Kostenloses Konto erstellen',
    logIn: 'Anmelden',
    check: 'Prüfen',
    checkWhyWorth: 'warum es sich lohnt',
  },
  widgetCalculator: {
    title:
      'Überprüfen Sie die Kurse und{{nbsp}}tauschen Sie Währungen in{{nbsp}}Walutomat – schnell und{{nbsp}}günstig.',
    actualRate: 'Wechselkurs',
    buySelect: 'Ich kaufe',
    sellSelect: 'Verkaufen',
    buttonText: 'Umtauschen',
    exchangeAmountSellLabel: 'Sie erhalten',
    exchangeAmountBuyLabel: 'Einzahlung',
    commission: 'Werbe-Provision ({{commission}}%)',
  },
  formValidation: {
    emptyField: 'Das Feld darf nicht leer sein',
    requiredField: 'Das Feld ist Pflichtfeld',
    requireAllFields: 'Alle Felder müssen ausgefüllt werden',
    passwordToShort: 'Das Passwort muss 8 Zeichen lang sein',
    emailNotValid: 'Das Feld muss eine gültige E-Mail Adresse enthalten',
    emailReserved: 'Die E-Mail-Adresse ist bereits vergeben',
    emailUnregistered: 'Die E-Mail-Adresse wurde nicht in unserer Kundendatenbank gefunden.',
    markField: 'Markieren Sie mindestens eines der Kontrollkästchen',
    serverUnknownError: 'Kommunikationsfehler des Servers',
    invalidCharacters: 'Feld enthält ungültige Zeichen',
    phoneNotValid: 'Die Telefonnummer ist falsch',
    checkBoxBelow: 'Bitte kreuzen Sie das Feld unten an, um eine Nachricht zu senden',
    promocodeInvalid: 'Ungültiger Promocode',
    newsletterAlreadySubscribed: 'Diese E-Mail-Adresse ist bereits für den Newsletter angemeldet.',
  },
  password: {
    show: 'anzeigen',
    hide: 'ausblenden',
  },
  howItWorks: {
    showButton: 'Mehr anzeigen',
    hideButton: 'Weniger anzeigen',
  },
}
